// Vendor Libs
import React from 'react';

// Components
import CreateShell from '../app/create-shell';
import FlexDashboard from '../core/flex-dashboard';
import MediaItemDetail from '../search-data/mediaitem-detail';
import MediaItems from '../search-data/media-items';
import CreateEditMediaItemOffering from '../app/create-edit-mediaitem-offering';
import MarkersTab from '../app/markers-tab';
import MoviesAndProgramsMapping from '../search-data/movies-and-programs-mapping';
import MoviesAndProgramsRelated from '../search-data/movies-and-programs-related';
import SearchBestMatches from '../app/search-best-matches';
import UnmappedMediaItems from '../search-data/unmapped-media-items';

// Configs
import getDashboardConfig from '../../../config/flex-dashboard-config';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'row',
                children: [
                    {
                        type: 'tabset',
                        children: [
                            {
                                id: 'MEDIAITEMDETAIL',
                                type: 'tab',
                                name: 'Media Item Detail',
                                component: MediaItemDetail,
                            },
                            {
                                type: 'tab',
                                name: 'Create/Edit Offerings',
                                component: CreateEditMediaItemOffering,
                            },
                            {
                                type: 'tab',
                                name: 'Markers',
                                component: MarkersTab,
                            },
                        ],
                    },
                    {
                        type: 'tabset',
                        children: [
                            {
                                id: 'MEDIAITEMS',
                                type: 'tab',
                                name: 'Media Items',
                                component: MediaItems,
                                config: {
                                    componentProps: {},
                                },
                            },
                            {
                                id: 'UNMAPPEDMEDIAITEMS',
                                type: 'tab',
                                name: 'Unmapped Media Items',
                                component: UnmappedMediaItems,
                                config: {
                                    componentProps: {
                                        detailLink: '/media-items',
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
            {
                type: 'tabset',
                children: [
                    {
                        id: 'BESTMATCHES',
                        type: 'tab',
                        name: 'Best Matches',
                        component: SearchBestMatches,
                    },
                    {
                        id: 'MOVIESANDPROGRAMSMAPPING',
                        type: 'tab',
                        name: 'Movies and Programs Mapping',
                        component: MoviesAndProgramsMapping,
                    },
                    {
                        id: 'CREATESHELL',
                        type: 'tab',
                        name: 'Create Shell',
                        component: CreateShell,
                    },
                    {
                        id: 'MOVIESANDPROGRAMSRELATED',
                        name: 'Associated Movies and Programs',
                        type: 'tab',
                        component: MoviesAndProgramsRelated,
                        config: {
                            componentProps: {
                                type: 'enhancedMediaItem',
                            },
                        },
                    },
                ],
            },
        ],
    },
};

function DashboardMediaItems() {
    return (
        <FlexDashboard dashboardConfig={getDashboardConfig(dashboardConfig)} dashboardName="mediaItems" version="3" />
    );
}

export default DashboardMediaItems;
